import React, { useEffect, useState } from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { TestimonialCard } from "../components/testimonial-card";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import {
  Star,
  Quote,
  Heart,
  Users,
  Award,
  ChevronRight
} from "lucide-react";
 
const INITIAL_COUNT = 10;
const LOAD_MORE_COUNT = 6;
 
export default function TestimonialsPage() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(INITIAL_COUNT);
 
  // Fetch testimonials from WordPress
  useEffect(() => {
    async function loadTestimonials() {
      try {
        const response = await fetch(
          "/wp-json/wp/v2/testimonials?per_page=100"
        );
 
        const data = await response.json();
        console.log("TESTIMONIAL PAGE DATA:", data);
 
        setTestimonials(Array.isArray(data) ? data : []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
        setLoading(false);
      }
    }
 
    loadTestimonials();
  }, []);
 
  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + LOAD_MORE_COUNT);
  };
 
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-br from-primary/10 to-primary/5">
        <div className="container px-4 mx-auto text-center">
          <Badge className="mb-4">Patient Stories</Badge>
 
          <h1 className="mb-4 text-4xl font-bold md:text-5xl lg:text-6xl">
            What Our Patients Say
          </h1>
 
          <p className="max-w-2xl mx-auto mb-8 text-lg text-muted-foreground">
            Real experiences from real patients. Discover how Pranaam Hospitals
            has made a difference in their lives.
          </p>
 
         
        </div>
      </section>
 
      {/* All Testimonials Grid */}
      <section className="py-16 bg-white">
        <div className="container px-4 mx-auto">
          <div className="mb-12 text-center">
            <h2 className="mb-4 text-3xl font-bold md:text-4xl">
              More Patient Experiences
            </h2>
            <p className="max-w-2xl mx-auto text-muted-foreground">
              Browse through hundreds of testimonials from patients across all
              our departments.
            </p>
          </div>
 
          {/* Loading State */}
          {loading && (
            <p className="text-center text-lg py-10">Loading testimonials...</p>
          )}
 
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {!loading &&
              testimonials.slice(0, visibleCount).map((item, index) => (
                <TestimonialCard
                  key={index}
                  quote={item.acf?.patient_review}
                  name={item.acf?.patient_name}
                  title={item.acf?.treatment_related_}
                  image={item.acf?.image || "/placeholder.svg"}
                  rating={item.acf?.patient_rating || 5}
                />
              ))}
          </div>
 
          {!loading && visibleCount < testimonials.length && (
            <div className="flex justify-center mt-12">
              <Button
                variant="outline"
                className="gap-2 bg-transparent"
                onClick={handleLoadMore}
              >
                Load More Testimonials
                <ChevronRight className="w-4 h-4" />
              </Button>
            </div>
          )}
        </div>
      </section>
 
     
 
      {/* CTA */}
      <section className="py-16 bg-gray-100">
        <div className="container px-4 mx-auto">
          <Card className="overflow-hidden border-0 shadow-xl">
            <div className="bg-gradient-to-r from-primary to-black p-12 text-center text-white">
              <h2 className="mb-4 text-3xl font-bold md:text-4xl">
                Experience World-Class Healthcare
              </h2>
              <p className="mb-8 max-w-2xl mx-auto text-lg text-white/90">
                Join thousands of satisfied patients who trust Pranaam Hospitals
                for their healthcare needs.
              </p>
 
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button size="lg" variant="secondary">
                  <a href="/book-now">Book Appointment</a>
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="bg-white text-primary hover:bg-white/90"
                >
                  <a href="/contact">Contact Us</a>
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </section>
    </div>
  );
}